export const usersConstants = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_ERROR: 'LOGIN_ERROR',


    GET_USER_DISHES_REQUEST: 'GET_USER_DISHES_REQUEST',
    GET_USER_DISHES_SUCCESS: 'GET_USER_DISHES_SUCCESS',
    GET_USER_DISHES_ERROR: 'GET_USER_DISHES_ERROR',

    GET_ADMIN_DETAIL_REQUEST: 'GET_ADMIN_DETAIL_REQUEST',
    GET_ADMIN_DETAIL_SUCCESS: 'GET_ADMIN_DETAIL_SUCCESS',
    GET_ADMIN_DETAIL_ERROR: 'GET_ADMIN_DETAIL_ERROR',

    GET_USER_REQUEST: 'GET_USER_REQUEST',
    GET_USER_SUCCESS: 'GET_USER_SUCCESS',
    GET_USER_ERROR: 'GET_USER_ERROR',

    GET_ADMIN_INVITED_USERS_REQUEST: 'GET_ADMIN_INVITED_USERS_REQUEST',
    GET_ADMIN_INVITED_USERS_SUCCESS: 'GET_ADMIN_INVITED_USERS_SUCCESS',
    GET_ADMIN_INVITED_USERS_ERROR: 'GET_ADMIN_INVITED_USERS_ERROR',

    INVITE_USER_BY_SMS_REQUEST: 'INVITE_USER_BY_SMS_REQUEST',
    INVITE_USER_BY_SMS_SUCCESS: 'INVITE_USER_BY_SMS_SUCCESS',
    INVITE_USER_BY_SMS_ERROR: 'INVITE_USER_BY_SMS_ERROR',

    EDIT_PROFILE_REQUEST: 'EDIT_PROFILE_REQUEST',
    EDIT_PROFILE_SUCCESS: 'EDIT_PROFILE_SUCCESS',
    EDIT_PROFILE_ERROR: 'EDIT_PROFILE_ERROR',

    EDIT_USER_PROFILE_REQUEST: 'EDIT_USER_PROFILE_REQUEST',
    EDIT_USER_PROFILE_SUCCESS: 'EDIT_USER_PROFILE_SUCCESS',
    EDIT_USER_PROFILE_ERROR: 'EDIT_USER_PROFILE_ERROR',

    CHANGE_PASS_REQUEST: 'CHANGE_PASS_REQUEST',
    CHANGE_PASS_SUCCESS: 'CHANGE_PASS_SUCCESS',
    CHANGE_PASS_ERROR: 'CHANGE_PASS_ERROR',

    CHANGE_USER_PASS_REQUEST: 'CHANGE_USER_PASS_REQUEST',
    CHANGE_USER_PASS_SUCCESS: 'CHANGE_USER_PASS_SUCCESS',
    CHANGE_USER_PASS_ERROR: 'CHANGE_USER_PASS_ERROR',

    RESET_REQUEST: 'RESET_REQUEST',
    RESET_SUCCESS: 'RESET_SUCCESS',
    RESET_ERROR: 'RESET_ERROR',

    FORGOT_REQUEST: 'FORGOT_REQUEST',
    FORGOT_SUCCESS: 'FORGOT_SUCCESS',
    FORGOT_ERROR: 'FORGOT_ERROR',

    GET_ADMIN_USER_DETAIL_REQUEST: 'GET_ADMIN_USER_DETAIL_REQUEST',
    GET_ADMIN_USER_DETAIL_SUCCESS: 'GET_ADMIN_USER_DETAIL_SUCCESS',
    GET_ADMIN_USER_DETAIL_ERROR: 'GET_ADMIN_USER_DETAIL_ERROR',

    CHANGE_USER_STATUS_REQUEST: 'CHANGE_USER_STATUS_REQUEST',
    CHANGE_USER_STATUS_SUCCESS: 'CHANGE_USER_STATUS_SUCCESS',
    CHANGE_USER_STATUS_ERROR: 'CHANGE_USER_STATUS_ERROR',

    DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',
    DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
    DELETE_USER_ERROR: 'DELETE_USER_ERROR',

    SEND_DELETE_ACCOUNT_OTP_REQUEST: 'SEND_DELETE_ACCOUNT_OTP_REQUEST',
    SEND_DELETE_ACCOUNT_OTP_SUCCESS: 'SEND_DELETE_ACCOUNT_OTP_SUCCESS',
    SEND_DELETE_ACCOUNT_OTP_ERROR: 'SEND_DELETE_ACCOUNT_OTP_ERROR',

    VERIFY_OTP_REQUEST: 'VERIFY_OTP_REQUEST',
    VERIFY_OTP_SUCCESS: 'VERIFY_OTP_SUCCESS',
    VERIFY_OTP_ERROR: 'VERIFY_OTP_ERROR',

    DELETE_ACCOUNT_WITH_OTP_REQUEST: 'DELETE_ACCOUNT_WITH_OTP_REQUEST',
    DELETE_ACCOUNT_WITH_OTP_SUCCESS: 'DELETE_ACCOUNT_WITH_OTP_SUCCESS',
    DELETE_ACCOUNT_WITH_OTP_ERROR: 'DELETE_ACCOUNT_WITH_OTP_ERROR',

    ADD_EXAM_REQUEST: 'ADD_EXAM_REQUEST',
    ADD_EXAM_SUCCESS: 'ADD_EXAM_SUCCESS',
    ADD_EXAM_ERROR: 'ADD_EXAM_ERROR',

    EDIT_EXAM_REQUEST: 'EDIT_EXAM_REQUEST',
    EDIT_EXAM_SUCCESS: 'EDIT_EXAM_SUCCESS',
    EDIT_EXAM_ERROR: 'EDIT_EXAM_ERROR',

    GET_EXAM_REQUEST: 'GET_EXAM_REQUEST',
    GET_EXAM_SUCCESS: 'GET_EXAM_SUCCESS',
    GET_EXAM_ERROR: 'GET_EXAM_ERROR',

    EDIT_SETTING_REQUEST: 'EDIT_SETTING_REQUEST',
    EDIT_SETTING_SUCCESS: 'EDIT_SETTING_SUCCESS',
    EDIT_SETTING_ERROR: 'EDIT_SETTING_ERROR',

    ADD_SETTING_REQUEST: 'ADD_SETTING_REQUEST',
    ADD_SETTING_SUCCESS: 'ADD_SETTING_SUCCESS',
    ADD_SETTING_ERROR: 'ADD_SETTING_ERROR',

    DELETE_EXAM_REQUEST: 'DELETE_EXAM_REQUEST',
    DELETE_EXAM_SUCCESS: 'DELETE_EXAM_SUCCESS',
    DELETE_EXAM_ERROR: 'DELETE_EXAM_ERROR',

};
